// Payment Tracking convergence — the frozen pre-v3 loan tape, rendered as
// read-only history. No legacy row is migrated, mutated, or re-enterable
// from the loan tab; the monthly-close page keeps its own workflow until
// its own convergence.

import { Card, StatusBadge, Table, TBody, TD, TH, THead, TR } from "@/design-system/components/ui";
import { formatCalendarDate } from "@/utils/datetime";
import type { ServicingLegacyEntryDto } from "@/api/portfolioAdmin/servicingApi";
import { fmtMoney } from "./servicingFormat";

export function LegacyHistorySection({
  entries,
}: {
  entries: ServicingLegacyEntryDto[];
}) {
  if (entries.length === 0) return null;

  return (
    <Card data-testid="legacy-history-section">
      <h3 className="font-display font-bold text-h3 m-0 mb-space-1">
        Historical (pre-v3)
      </h3>
      <p className="text-caption text-gray-mid m-0 mb-space-3">
        Frozen loan-tape entries — read-only history from before the Payment
        System v3 convergence.
      </p>
      <Table>
        <THead>
          <TR>
            <TH>Period</TH>
            <TH className="text-right">Scheduled</TH>
            <TH className="text-right">Received</TH>
            <TH>Received on</TH>
            <TH className="text-right">Days late</TH>
            <TH>Status</TH>
          </TR>
        </THead>
        <TBody>
          {entries.map((e) => (
            <TR key={e.id} data-testid={`legacy-entry-${e.collectionPeriod}`}>
              <TD>{e.collectionPeriod}</TD>
              <TD className="text-right tabular-nums">
                {fmtMoney(e.scheduledPaymentAmount)}
              </TD>
              <TD className="text-right tabular-nums">
                {e.paymentReceivedAmount !== null ? fmtMoney(e.paymentReceivedAmount) : "—"}
              </TD>
              <TD>{e.paymentReceivedDate ? formatCalendarDate(e.paymentReceivedDate) : "—"}</TD>
              <TD className="text-right tabular-nums">{e.daysLate}</TD>
              <TD>
                <StatusBadge tone={e.status === "locked" ? "neutral" : "muted"}>
                  {e.status}
                </StatusBadge>
              </TD>
            </TR>
          ))}
        </TBody>
      </Table>
    </Card>
  );
}
